import { Reveal, Overline } from "./Reveal";

export default function Intro() {
  return (
    <section id="sobre" className="py-28 md:py-40" data-testid="intro-section">
      <div className="mx-auto grid max-w-7xl gap-16 px-6 lg:grid-cols-12 lg:gap-10 lg:px-10">
        <div className="lg:col-span-5">
          <Reveal>
            <Overline>A Creative</Overline>
            <h2 className="mt-6 font-display text-4xl font-medium leading-[1.05] tracking-tight text-royal-deep md:text-6xl">
              Estratégia e <em className="text-royal">criatividade,</em>
              <br />
              sob o mesmo teto.
            </h2>
          </Reveal>
        </div>
        <div className="lg:col-span-6 lg:col-start-7">
          <Reveal delay={0.15}>
            <p className="text-lg leading-relaxed text-foreground/80 md:text-xl">
              A Creative é uma agência criativa que junta estratégia, marketing, design,
              fotografia e vídeo.
            </p>
            <p className="mt-6 text-base leading-relaxed text-muted-foreground">
              Pensamos as marcas antes de as desenhar e depois transformamos essa visão em
              identidade, conteúdo, imagem e movimento. Criamos soluções que não são apenas
              bonitas, mas que fazem sentido para as marcas e geram resultados.
            </p>
          </Reveal>

          <Reveal delay={0.3} className="mt-14">
            <div className="flex flex-wrap items-center gap-x-5 gap-y-4 border-y border-royal-line py-8">
              <span className="font-display text-3xl font-medium text-royal-deep md:text-4xl">
                Estratégia
              </span>
              <span className="font-display text-3xl italic text-royal md:text-4xl">+</span>
              <span className="font-display text-3xl font-medium text-royal-deep md:text-4xl">
                Criatividade
              </span>
              <span className="font-display text-3xl italic text-royal md:text-4xl">=</span>
              <img src="/assets/logo-blue.png" alt="Creative" className="h-10 w-auto md:h-12" />
            </div>
            <p className="mt-6 text-sm font-semibold uppercase tracking-[0.22em] text-muted-foreground">
              Uma equipa completa, do pensamento à execução.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
